/**
 * Exclusive-open fallback for grouped <details> accordions (M12, M29).
 *
 * Each group's markup already sets `name="…"` on every <details> in it,
 * which makes them mutually exclusive natively — zero JS — in browsers that
 * support shared `name` on details (Safari 17.4+, Chrome/Edge 120+, Firefox
 * 122+). This file is only the fallback for older browsers that ignore
 * `name` and would otherwise let every panel stay open at once. Where native
 * support already closed the siblings, `other.open = false` below is a
 * harmless no-op — this never double-fires or fights the native behaviour.
 *
 * With JS disabled entirely, panels simply don't force each other shut,
 * which is a fine degraded state (rule 7) — nothing here is required for
 * the content to be visible or usable.
 */
(function accordionExclusiveOpen() {
  document.querySelectorAll('[data-accordion-group]').forEach((group) => {
    const items = [...group.querySelectorAll(':scope > details')];

    items.forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        items.forEach((other) => {
          if (other !== details) other.open = false;
        });
      });
    });
  });
})();
